import React, { useState, useEffect, useReducer } from "react";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { useParams, Link } from "react-router-dom";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import settingsReducer from "../../reducers/settings";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import Site from "./Site";
import * as utils from "../../common/utils";
import * as actions from "../../actions/siteDetails";

import siteReducer from "../../reducers/siteDetails";
import {
  getUserData,
  fetchSiteLocations,
  fetchPinnedSites,
} from "../../reducers/siteSettings";
import ReasonCodes from "./ReasonCodes";
import GembaTypes from "./GembaTypes";
import People from "./People";
import Tiers from "./Tiers";
import { postUserLog } from "../../actions/common";
import IncidentType from "./IncidentType";
import CalendarEventType from "./CalendarEventType";
import ModuleMenu from "../common/moduleMenu/ModuleMenu";
import Vizualization from "./Vizualization";
//import OPHMissReasonCodes from './OPHMissReasonCodes';
import HSE from "./HSECommunication";
import ScheduledReport from "./ScheduledReport";
import MultiSurvey from "./MultiSurvey";

const initialState = {
  siteLocations: [],
  tiers: [],
  userDetails: [],
  pinSiteStatus: null,
  pinnedSites: [],
};

const Settings = (props) => {
  const { category, app, site } = useParams();
  //const [state, dispatch] = useReducer(settingsReducer, initialState);
  const dispatch = useDispatch();
  //const { userDetails } = state;
  const settingsState = useSelector((state) => state.settings);
  const { userDetails, siteLocations, pinnedSites } = settingsState;
  const [animate, setAnimate] = useState("");
  const [isEditable, setIsEditable] = useState(null);
  const [parentTierID, setParentTierID] = useState(null);
  // useEffect(() => {
  //   actions.getUserData(dispatch, site);
  // }, []);

  useEffect(() => {
    dispatch(getUserData(site));
    dispatch(fetchPinnedSites(category));
    dispatch(fetchSiteLocations(category));
    setTimeout(() => {
      setAnimate("animate");
    }, 250);
  }, [dispatch]);

  useEffect(() => {
    setIsEditable(userDetails ? utils.isEditable(userDetails) : null);
  }, [userDetails]);
  useEffect(() => {
    getSiteTierID();
  }, [siteLocations]);
  const updatePinSite = () => {
    let site = getSitInfo();
    let isPinned = site.isPinned ? false : true;
    let pinStatus = isPinned ? "pinned" : "unpinned";
    actions.updatePinSite(
      dispatch,
      `siteid=${site.siteId}&pinned=${isPinned}`,
      category
    );
    postUserLog({
      event: "Pin/UnPin Site",
      data: {
        action: site.siteName + " site " + pinStatus,
        module: "Site Settings",
        section: "Header",
        siteUId: site.siteId,
        widget: "",
      },
    });
  };
  const getSitInfo = () => {
    let data = _.find(siteLocations, ["siteId", site]);
    return data;
  };
  const getSiteInfo = () => {
    let data = _.find(siteLocations, function (n) {
      if (n.siteId === site && n.tierlevel === 4) {
        return n;
      }
    });

    return data;
  };

  const getSiteName = () => {
    let data = getSitInfo();
    return data ? data.siteName : "";
  };

  const getSiteTierID = () => {
    let data = getSiteInfo();
    setParentTierID(data ? data.tierID : 0);
    return data ? data.tierID : 0;
  };

  const gridDetails = [
    { id: 0, text: "Site", icon: "product", component: <Site siteId={site} /> },
    {
      id: 1,
      text: "People",
      icon: "money",
      component: <People siteId={site} isEditableFlag={isEditable} />,
    },
    {
      id: 2,
      text: "Reason Codes",
      icon: "group",
      component: <ReasonCodes siteId={site} />,
    },
    { id: 3, text: "Tiers", icon: "card", component: <Tiers siteId={site} /> },
    // {
    //   id: 4,
    //   text: "Multi-Survey",
    //   icon: "group",
    //   component: <MultiSurvey siteId={site} parentTierID={parentTierID} />,
    // },
    // {
    //   id: 5,
    //   text: "Gemba Types",
    //   icon: "chart",
    //   component: <GembaTypes siteId={site} />,
    // },
    // {
    //   id: 6,
    //   text: "Calender Event Types",
    //   icon: "chart",
    //   component: <CalendarEventType siteId={site} />,
    // },
    //  { id: 6, text: 'Visualization', icon: 'chart', component: <Vizualization siteId={site} /> },
    // {
    //   id: 7,
    //   text: "Incident Type",
    //   icon: "chart",
    //   component: <IncidentType siteId={site} />,
    // },
    // {
    //   id: 7,
    //   text: "Pinned E-Mail",
    //   icon: "chart",
    //   component: <PinnedMail siteId={site} isEditableFlag={isEditable} />,
    // },
    //{ id: 9, text: 'OPH Miss Reason Codes', icon: 'chart', component: <OPHMissReasonCodes siteId={site} /> },
    // {
    //   id: 8,
    //   text: "HSE Communications",
    //   icon: "chart",
    //   component: <HSE siteId={site} />,
    // },
    // {
    //   id: 9,
    //   text: "Scheduled Reports",
    //   icon: "chart",
    //   component: <ScheduledReport siteId={site} />,
    // },
  ];
  return (
    <>
      <Header showPinBtn={updatePinSite} site={getSitInfo()} />
      <section className="page-content">
        <div className="site-view tier-wrap">
          <div className={"site-list " + animate}>
            <div className="breadcrumb">
              <span
                className={"icon icon-" + utils.getSbgName(category)}
              ></span>

              <ul>
                <li>
                  <Link to={`/home/${category}`}>
                    {utils.getSbgNameTxt(category)}
                  </Link>
                </li>
                <li>
                  <Link to={`/sitehome/${category}/${site}`}>
                    {getSiteName()}
                  </Link>
                </li>
                <li>Settings</li>
              </ul>
            </div>
            <div className="site-head">
              <div className="page-heading">
                <h2>
                  <span className="icon setting"></span> Settings
                </h2>
              </div>
            </div>

            <ModuleMenu componentsData={gridDetails} />
          </div>
        </div>
      </section>
      <Footer
        showThemeSwitch={true}
        hideSiteCount={true}
        activeSites={pinnedSites}
        sbg={category}
      />
    </>
  );
};
export default Settings;
